module.exports = __webpack_public_path__ + "img/tpc-20.b7a62b3a.jpg";